import { render, staticRenderFns } from "./ShiftList.vue?vue&type=template&id=c903d448&scoped=true&"
import script from "./ShiftList.vue?vue&type=script&lang=js&"
export * from "./ShiftList.vue?vue&type=script&lang=js&"
import style0 from "./ShiftList.vue?vue&type=style&index=0&id=c903d448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c903d448",
  null
  
)

component.options.__file = "ShiftList.vue"
export default component.exports